import { useAuth } from "@wtc/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { logger } from "@/lib/logger";
import { sendMessage } from "./api-client/index";
import type { SendMessageVariables } from "./types";

/**
 * Hook for sending new messages
 */
export function useSendMessage() {
  const queryClient = useQueryClient();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  return useMutation({
    mutationFn: (variables: SendMessageVariables) => sendMessage(variables, token || undefined),
    onMutate: (variables) => {
      if (process.env.NODE_ENV === "development") {
        logger.info("🔄 useSendMessage mutation started with variables", { variables });
      }
    },
    onSuccess: (data) => {
      if (process.env.NODE_ENV === "development") {
        logger.info("✅ useSendMessage mutation succeeded with data", { data });
      }
      toast.success("Message sent successfully");
      // We can't know which message list to invalidate, so we invalidate all
      void queryClient.invalidateQueries({ queryKey: ["messages"] });
    },
    onError: (error) => {
      if (process.env.NODE_ENV === "development") {
        logger.error("❌ useSendMessage mutation failed with error", error);
      }
      toast.error(`Failed to send message: ${error.message}`);
    },
  });
}
